import React from 'react'
import type { RichTextBlock as BlockProps } from '@/payload-types'
import RichText from '@/components/RichText'
import { cn } from '@/utilities/cn'

export const RichTextBlock: React.FC<BlockProps> = ({ content, enableProse, paragraphBottomMargin, primaryLinks, className }) => {
  return (
    <RichText
      enableGutter={false}
      content={content ?? {}}
      enableProse={enableProse ?? false}
      className={cn(
        primaryLinks && 'primary-links',
        paragraphBottomMargin && 'paragraphs-mb-4',
        className
      )}
    />
  )
}
